import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';
import { zindex } from 'app/shared/styles/_zindex';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

export const Header = styled.header`
  ${stacked._2x};
`;
export const MasterTitle = styled.h1`
  ${font.md};
  color: ${colors['$hpx-blue-600']};
  font-weight: bold;
`;

export const MainPagingText = styled.p`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  font-weight: bold;
  ${stacked._1x};
`;

export const SecondaryPagingText = styled.span`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  font-weight: normal;
`;

export const ScreenReaderOnly = styled.h2`
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const ButtonSection = styled.section`
  display: flex;
  justify-content: space-between;
  position: relative;
`;

export const TransparentOverlay = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${zindex['$z-index-step-over']};
  background: transparent;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 195px;
  left: 16px;
  width: 176px;
  margin-top: 4px;
  color: ${colors['$hpx-blue-600']};
  cursor: pointer;
  background-color: ${colors['$hpx-white']};
  border-radius: 4px;
  border: solid 1px ${colors['$hpx-grey-500']};
  z-index: ${zindex['$z-index-parent']};
`;

export const DropdownListItem = styled.li`
  ${font.sm};
  width: 100%;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
  padding: 8px 16px;
`;

export const AlertsButton = styled(ButtonBase)`
  width: 118px;
  position: relative;
  color: ${colors['$hpx-teal-500']};
  white-space: nowrap;
`;

export const SelectButton = styled.select`
  font-size: 14px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: ${colors['$hpx-white']};
  border: 1px solid ${colors['$hpx-grey-500']};
  border-radius: 4px;
  padding: 8px 27px 8px 8px;
  letter-spacing: 0.5px;
  color: ${colors['$hpx-blue-600']};
`;

export const SelectButtonArrow = styled.img`
  line-height: 0px;
  color: ${colors['$hpx-grey-600']};
  pointer-events: none;
  position: absolute;
  left: 150px;
  top: 10px;
`;
